<template>
  <div>
    <vs-breadcrumb
      class="mb-6"
      :items="[
        {
          title: '订单',
          url: '/order/index',
        },
        {
          title: '订单管理',
          active: true,
        },
      ]"
    ></vs-breadcrumb>

    <div class="mb-2">
      <vx-input-group class>
        <vs-input v-model="keyword" placeholder="输入订单关键词" />
        <template slot="append">
          <div class="append-text btn-addon">
            <vs-button color="primary" @click="queryOrder">搜索订单</vs-button>
          </div>
        </template>
      </vx-input-group>
    </div>

    <div class="mb-2">
      <div class="vx-row">
        <div class="vx-col w-full lg:w-1/2">
          <flat-pickr
            :config="configdateTimePicker"
            v-model="start"
            placeholder="选择查询开始时间"
            class="w-full"
          />
        </div>
        <div class="vx-col w-full lg:w-1/2">
          <flat-pickr
            :config="configdateTimePicker"
            v-model="end"
            placeholder="选择查询结束时间"
            class="w-full"
          />
        </div>
      </div>
    </div>
    <div class="mb-2">
      <vs-button class="mr-2" color="primary" @click="exportOrder($event)"
        >导出订单</vs-button
      >

      <!-- <vs-button color="primary"
        @click="openImportModal"
      >
        导入第三方订单
      </vs-button> -->

      <div class="app-upload-button mr-2">
        <span>导入第三方订单</span>
        <input type="file" @change="handleFileChange" ref="inputer" />
      </div>

      <!-- <vs-button color="primary"
        @click="openImportModal"
      >
        导入第三方订单
      </vs-button> -->
      <vs-button color="primary" @click="getDemo">下载订单模板</vs-button>
      <div style="display: inline-block">
        <div
          style="
            display: flex;
            align-items: center;
            color: #7367f0;
            cursor: pointer;
          "
        >
          <feather-icon
            icon="RefreshCcwIcon"
            svgClasses="w-5 h-5 hover:text-success stroke-current a-hover"
            @click.stop="refresh"
            class="ml-4"
          />
        </div>
      </div>
    </div>
    <div class="mb-6">
      <template v-for="item in statusList">
        <vs-button
          :key="item.id"
          class="mr-1"
          v-if="item.active"
          @click="queryOrderByStatus(item.value, item.id)"
          >{{ item.name }}</vs-button
        >
        <vs-button
          :key="item.id"
          class="mr-1"
          v-else
          type="border"
          @click="queryOrderByStatus(item.value, item.id)"
          >{{ item.name }}</vs-button
        >
      </template>
    </div>
    <div class="order-table">
      <vs-table
        ref="table"
        :notSpacer="false"
        :stripe="true"
        :max-items="itemsPerPage"
        :data="list"
        :noDataText="noDataText"
      >
        <template slot="thead">
          <vs-th width="12%">
            序号/订单号/创建时间
            <br />收件人信息 <br />身份证信息
          </vs-th>
          <vs-th width="1%" class="whitespace-no-wrap">订单状态</vs-th>
          <vs-th width="9%">物流信息</vs-th>
          <vs-th width="10%">订单金额</vs-th>
          <vs-th width="2%">操作</vs-th>

          <vs-th width="19%">商品</vs-th>
          <vs-th width="12%">订单推单状态</vs-th>
          <vs-th width="12%">清单推单状态</vs-th>
          <vs-th width="12%">运单推单状态</vs-th>
          <vs-th width="12%">支付单推单状态</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">
              <!-- 序号/订单号/创建时间 -->
              <vs-td>
                <div style="width: 160px">
                  <p class="product-name font-medium truncate">#{{ tr.id }}</p>
                  <p class="product-name font-medium truncate">
                    {{ tr.order_id }}
                  </p>
                  <p class="text-muted">{{ tr.created_at }}</p>
                  <div class="mt-2 font-bold">
                    <p>#收件人信息#</p>
                    {{ tr.name }}
                    <br />
                    {{ tr.phone }}
                    <br />
                    {{ tr.province }} {{ tr.city }} {{ tr.district }}
                    {{ tr.address }}
                  </div>
                  <div class="mt-2 font-bold">
                    <p>#身份证信息#</p>
                    <p>{{ tr.realname }} {{ tr.idcard }}</p>
                  </div>
                </div>
              </vs-td>
              <vs-td>
                <p class="clear" style="width: 80px">
                  <span class="text-primary" v-if="tr.status == 0">待付款</span>
                  <span class="text-primary" v-else-if="tr.status === 1"
                    >待发货</span
                  >
                  <span class="text-primary" v-else-if="tr.status === 2"
                    >待收货</span
                  >
                  <span class="text-primary" v-else-if="tr.status === 3"
                    >已完成</span
                  >
                  <span class="text-primary" v-else-if="tr.status === 4"
                    >已取消</span
                  >
                  <span class="text-primary" v-else-if="tr.status === 5"
                    >退款中</span
                  >
                  <span class="text-primary" v-else-if="tr.status === 6"
                    >退款完成</span
                  >
                </p>
              </vs-td>
              <!-- 物流信息 -->
              <vs-td>
                <div style="width: 120px">
                  <div style="white-space: nowrap">
                    <div v-if="tr.logistics_company">
                      {{ tr.logistics_company }}
                      <br />
                      {{ tr.logistics_number }}
                    </div>
                  </div>
                  <div
                    v-if="!tr.logistics_company && tr.status == 1"
                    style="cursor: pointer"
                  >
                    <a
                      href="javascript:void(0)"
                      @click="openLogistics(tr)"
                      class="mr-1"
                      >更新</a
                    >
                  </div>
                </div>
              </vs-td>

              <vs-td>
                <div style="width: 80px">
                  <p class="font-bold">
                    商品总金额:
                    <br />
                    {{ tr.goods_price }}
                  </p>
                  <p class="text-muted">
                    总运费:
                    <br />
                    +{{ tr.express }}
                  </p>
                  <p class="text-muted" v-if="tr.coupon_id">
                    优惠券金额:
                    <br />
                    -{{ tr.coupon_amount }}
                  </p>
                  <p class="text-danger font-bold">
                    订单总金额:
                    <br />
                    {{ tr.total_price }}
                  </p>
                </div>
              </vs-td>

              <vs-td width="2%">
                <div style="cursor: pointer; width: 80px">
                  <a
                    class="whitespace-no-wrap"
                    @click.prevent="openPushDetail(tr.order_id)"
                    >推单信息</a
                  >
                  <div class="flex">
                    <a
                      v-if="tr.status === 0"
                      class="whitespace-no-wrap mr-2 inline-block"
                      style="color: #fd7e15"
                      @click.prevent="openPay(tr)"
                      >付款</a
                    >
                    <a
                      class="whitespace-no-wrap inline-block"
                      style="color: #fd7e15"
                      @click.prevent="deletes(tr)"
                      >删除</a
                    >
                  </div>
                </div>
              </vs-td>

              <!-- 商品 -->
              <vs-td>
                <div class="shop-info-insert" style="width: 450px">
                  <vs-table noDataText>
                    <template slot="thead">
                      <vs-th width="15%">商品封面</vs-th>
                      <vs-th width="20%">
                        商品名称
                        <br />来自供货商 <br />单价
                      </vs-th>
                      <vs-th width="12%">数量</vs-th>
                      <vs-th width="15%">
                        总运费
                        <br />商品总金额
                      </vs-th>
                      <!-- <vs-th width="15%">状态</vs-th> -->
                    </template>
                    <template>
                      <vs-tr v-for="sub in tr.items" :key="sub.id">
                        <vs-td style="width: 100px">
                          <img
                            :src="
                              sub.image
                                ? sub.image
                                : require('@/assets/images/placeholder/5x4.png')
                            "
                            class="w-full"
                          />
                        </vs-td>
                        <vs-td
                          ><div style="width: 150px">
                            {{ sub.name }}
                            <br />
                            <span class="text-muted">
                              #供货商:
                              {{ sub.store ? sub.store.store_name : '' }}
                            </span>
                            <br />
                            #规格: {{ sub.unit }}
                            <br />
                            <span class="font-bold">{{ sub.price }}</span>
                          </div>
                        </vs-td>
                        <vs-td>{{ sub.count }}</vs-td>
                        <vs-td>
                          <span class="text-muted">
                            总运费:
                            <br />
                            {{ sub.express }}
                          </span>
                          <br />
                          <span class="font-bold">
                            总金额:
                            <br />
                            {{ sub.total_price }}
                          </span>
                        </vs-td>
                        <!-- <vs-td>
                      <a
                        href="javascript:void(0)"
                        @click="openStatus(sub)"
                        v-if="
                          sub.status === 1 ||
                          sub.status === 2 ||
                          sub.status === 3
                        "
                      >
                        <span
                          class="text-primary"
                          v-if="sub.status === 1"
                        >{{
                          sub.statusName
                        }}</span>
                        <span
                          class="text-warning"
                          v-if="sub.status === 2"
                        >{{
                          sub.statusName
                        }}</span>
                        <span
                          class="text-success"
                          v-if="sub.status === 3"
                        >{{
                          sub.statusName
                        }}</span>
                      </a>
                      <span v-if="sub.status === 0">{{ sub.statusName }}</span>
                      <span
                        class="text-danger"
                        v-if="
                          sub.status === 4 ||
                          sub.status === 5 ||
                          sub.status === 6
                        "
                      >{{ sub.statusName }}</span>
                    </vs-td> -->
                      </vs-tr>
                    </template>
                  </vs-table>
                </div>
              </vs-td>

              <vs-td class="order-td" style="position: relative">
                <div>
                  <div
                    style="
                      display: flex;
                      flex-flow: row nowrap;
                      align-items: center;
                    "
                  >
                    <div
                      v-if="
                        !tr.pushStatus &&
                        tr.pushLog.length &&
                        tr.orderReturn3.returnOneArr[0]
                      "
                      style="font-size: 12px; color: #7367f0"
                    >
                      <span class="label danger">订单状态未知</span>
                    </div>

                    <div
                      v-if="tr.pushStatus"
                      style="font-size: 12px; color: #7367f0"
                    >
                      <span
                        class="label danger"
                        v-if="tr.pushStatus.orderStatus < 0"
                        >系统异常处理</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 0"
                        >无操作</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 1"
                        >电子口岸已暂存</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 2"
                        >电子口岸申报中</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 3"
                        >发送海关成功</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.orderStatus == 4"
                        >发送海关失败</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 5"
                        >预处理成功</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.orderStatus == 100"
                        >海关退单</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 120"
                        >海关入库</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 200"
                        >数据已接收</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 300"
                        >人工审核</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 399"
                        >海关审结</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 400"
                        >待运抵</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 500"
                        >查验</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.orderStatus == 501"
                        >扣留移送通关</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.orderStatus == 502"
                        >扣留移送缉私</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.orderStatus == 503"
                        >扣留移送法规</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.orderStatus == 599"
                        >其它扣留</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 700"
                        >退运</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 800"
                        >放行</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 899"
                        >结关</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 900"
                        >退货</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 1001"
                        >身份验证中</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.orderStatus == 1002"
                        >身份验证不通过</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 1003"
                        >平台已暂存</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.orderStatus == 1006"
                        >正在发往电子口岸</span
                      >

                      <span class="label red" v-else>订单未知状态</span>
                    </div>
                  </div>

                  <!-- wenben -->
                  <div>
                    <div class="td-push" style="margin-bottom: 28px">
                      <div
                        :key="eIndex"
                        v-for="(error, eIndex) in tr.orderReturn3.returnOneArr"
                      >
                        <!-- <span :class="{ 'font-space': true }"> -->
                        <span style="width: 100%">
                          {{ error.updated_at }}
                          {{ error.error }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      position: absolute;
                      width: calc(100% - 30px);
                      left: 15px;
                      bottom: 10px;
                      display: flex;
                      align-items: center;
                      height: 27.5px;
                    "
                  >
                    <a
                      v-if="tr.orderReturn3.returnOneArr[0]"
                      style="cursor: pointer"
                      href="javascript:void(0)"
                      @click="
                        openPushStatusDetailDialog(
                          tr.orderReturn3.returnArrs,
                          tr.pushStatus,
                          '3'
                        )
                      "
                      >查看详情</a
                    >
                  </div>
                </div>
              </vs-td>
              <vs-td class="order-td" style="position: relative">
                <div>
                  <div
                    style="
                      display: flex;
                      flex-flow: row nowrap;
                      align-items: center;
                    "
                  >
                    <div
                      v-if="
                        !tr.pushStatus &&
                        tr.pushLog.length &&
                        tr.orderReturn4.returnOneArr[0]
                      "
                      style="font-size: 12px; color: #7367f0"
                    >
                      <span class="label danger">订单状态未知</span>
                    </div>
                    <div
                      v-if="tr.pushStatus"
                      class="whitespace-no-wrap"
                      style="font-size: 12px; color: #7367f0"
                    >
                      <span
                        class="label danger"
                        v-if="tr.pushStatus.inventoryStatus < 0"
                        >系统异常处理</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 0"
                        >无操作</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 1"
                        >电子口岸已暂存</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 2"
                        >电子口岸申报中</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 3"
                        >发送海关成功</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.inventoryStatus == 4"
                        >发送海关失败</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 5"
                        >预处理成功</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.inventoryStatus == 100"
                        >海关退单</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 120"
                        >海关入库</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 200"
                        >数据已接收</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 300"
                        >人工审核</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 399"
                        >海关审结</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 400"
                        >待运抵</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 500"
                        >查验</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.inventoryStatus == 501"
                        >扣留移送通关</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.inventoryStatus == 502"
                        >扣留移送缉私</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.inventoryStatus == 503"
                        >扣留移送法规</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.inventoryStatus == 599"
                        >其它扣留</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 700"
                        >退运</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 800"
                        >放行</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 899"
                        >结关</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 900"
                        >退货</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 1001"
                        >身份验证中</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.inventoryStatus == 1002"
                        >身份验证不通过</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 1003"
                        >平台已暂存</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.inventoryStatus == 1006"
                        >正在发往电子口岸</span
                      >

                      <span class="label red" v-else>订单未知状态</span>
                    </div>
                  </div>

                  <!-- wenben -->
                  <div>
                    <div class="td-push" style="margin-bottom: 28px">
                      <div
                        :key="eIndex"
                        v-for="(error, eIndex) in tr.orderReturn4.returnOneArr"
                      >
                        <span :class="{ 'font-space': true }">
                          {{ error.updated_at }}
                          {{ error.error }}
                        </span>
                      </div>
                    </div>

                    <div
                      style="
                        position: absolute;
                        width: calc(100% - 30px);
                        left: 15px;
                        bottom: 10px;
                        display: flex;
                        align-items: center;
                        height: 27.5px;
                      "
                    >
                      <a
                        v-if="tr.orderReturn4.returnOneArr[0]"
                        style="cursor: pointer"
                        href="javascript:void(0)"
                        @click="
                          openPushStatusDetailDialog(
                            tr.orderReturn4.returnArrs,
                            tr.pushStatus,
                            '4'
                          )
                        "
                        >查看详情</a
                      >
                    </div>
                  </div>
                </div>
              </vs-td>

              <vs-td class="order-td" style="position: relative">
                <div>
                  <div
                    style="
                      display: flex;
                      flex-flow: row nowrap;
                      align-items: center;
                    "
                  >
                    <div
                      v-if="
                        !tr.pushStatus &&
                        tr.pushLog.length &&
                        tr.orderReturn1.returnOneArr[0]
                      "
                      style="font-size: 12px; color: #7367f0"
                    >
                      <span class="label danger">订单状态未知</span>
                    </div>
                    <div
                      v-if="tr.pushStatus"
                      class="whitespace-no-wrap"
                      style="font-size: 12px; color: #7367f0"
                    >
                      <span
                        class="label danger"
                        v-if="tr.pushStatus.logisticsStatus < 0"
                        >系统异常处理</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 0"
                        >无操作</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 1"
                        >电子口岸已暂存</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 2"
                        >电子口岸申报中
                      </span>

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 3"
                        >发送海关成功</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.logisticsStatus == 4"
                        >发送海关失败</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 5"
                        >预处理成功</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.logisticsStatus == 100"
                        >海关退单</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 120"
                        >海关入库</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 200"
                        >数据已接收</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 300"
                        >人工审核</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 399"
                        >海关审结</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 400"
                        >待运抵</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 500"
                        >查验</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.logisticsStatus == 501"
                        >扣留移送通关</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.logisticsStatus == 502"
                        >扣留移送缉私</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.logisticsStatus == 503"
                        >扣留移送法规</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.logisticsStatus == 599"
                        >其它扣留</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 700"
                        >退运</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 800"
                        >放行</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 899"
                        >结关</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 900"
                        >退货</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 1001"
                        >身份验证中</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.logisticsStatus == 1002"
                        >身份验证不通过</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 1003"
                        >平台已暂存</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.logisticsStatus == 1006"
                        >正在发往电子口岸</span
                      >

                      <span class="label red" v-else>订单未知状态</span>
                    </div>
                  </div>

                  <!-- wenben -->
                  <div>
                    <div class="td-push" style="margin-bottom: 28px">
                      <div
                        :key="eIndex"
                        v-for="(error, eIndex) in tr.orderReturn1.returnOneArr"
                      >
                        <span :class="{ 'font-space': true }">
                          {{ error.updated_at }}
                          {{ error.error }}
                        </span>
                      </div>
                    </div>

                    <div
                      style="
                        position: absolute;
                        width: calc(100% - 30px);
                        left: 15px;
                        bottom: 10px;
                        display: flex;
                        align-items: center;
                        height: 27.5px;
                      "
                    >
                      <a
                        v-if="tr.orderReturn1.returnOneArr[0]"
                        style="cursor: pointer"
                        href="javascript:void(0)"
                        @click="
                          openPushStatusDetailDialog(
                            tr.orderReturn1.returnArrs,
                            tr.pushStatus,
                            '1'
                          )
                        "
                        >查看详情</a
                      >
                    </div>
                  </div>
                </div>
              </vs-td>
              <vs-td class="order-td" style="position: relative">
                <div>
                  <div
                    style="
                      display: flex;
                      flex-flow: row nowrap;
                      align-items: center;
                    "
                  >
                    <div
                      v-if="
                        !tr.pushStatus &&
                        tr.pushLog.length &&
                        tr.orderReturn2.returnOneArr[0]
                      "
                      style="font-size: 12px; color: #7367f0"
                    >
                      <span class="label danger">订单状态未知</span>
                    </div>
                    <div
                      v-if="tr.pushStatus"
                      class="whitespace-no-wrap"
                      style="font-size: 12px; color: #7367f0"
                    >
                      <span
                        class="label light-blue"
                        v-if="tr.pushStatus.paymentStatus == 0"
                        >未报送</span
                      >
                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 1"
                        >报送中</span
                      >
                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 2"
                        ><span v-if="tr.pay_name == 'mobao'">摩宝</span>
                        <span v-if="tr.pay_name == 'xinsheng'">新生</span>
                        <span v-if="tr.pay_name == 'tonglian'">通联</span
                        >推送成功</span
                      >
                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.paymentStatus == 3"
                        >失败</span
                      >
                      <span class="label red" v-else>未知状态</span>
                    </div>
                    <!-- <div
                      v-if="tr.pushStatus"
                      class="whitespace-no-wrap"
                      style="font-size: 12px; color: #7367f0"
                    >
                      <span
                        class="label danger"
                        v-if="tr.pushStatus.paymentStatus < 0"
                        >系统异常处理</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 0"
                        >无操作</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 1"
                        >电子口岸已暂存</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 2"
                        >电子口岸申报中</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 3"
                        >发送海关成功</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.paymentStatus == 4"
                        >发送海关失败</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 5"
                        >预处理成功</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.paymentStatus == 100"
                        >海关退单</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 120"
                        >海关入库</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 200"
                        >数据已接收</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 300"
                        >人工审核</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 399"
                        >海关审结</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 400"
                        >待运抵</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 500"
                        >查验</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.paymentStatus == 501"
                        >扣留移送通关</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.paymentStatus == 502"
                        >扣留移送缉私</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.paymentStatus == 503"
                        >扣留移送法规</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.paymentStatus == 599"
                        >其它扣留</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 700"
                        >退运</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 800"
                        >放行</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 899"
                        >结关</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 900"
                        >退货</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 1001"
                        >身份验证中</span
                      >

                      <span
                        class="label red"
                        v-else-if="tr.pushStatus.paymentStatus == 1002"
                        >身份验证不通过</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 1003"
                        >平台已暂存</span
                      >

                      <span
                        class="label light-blue"
                        v-else-if="tr.pushStatus.paymentStatus == 1006"
                        >正在发往电子口岸</span
                      >

                      <span class="label red" v-else>订单未知状态</span>
                    </div> -->
                  </div>

                  <!-- wenben -->
                  <div>
                    <div class="td-push" style="margin-bottom: 28px">
                      <div
                        :key="eIndex"
                        v-for="(error, eIndex) in tr.orderReturn2.returnOneArr"
                      >
                        <span :class="{ 'font-space': true }">
                          {{ error.updated_at }}
                          {{ error.error }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style="
                    position: absolute;
                    width: calc(100% - 30px);
                    left: 15px;
                    bottom: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    height: 27.5px;
                  "
                >
                  <a
                    v-if="tr.orderReturn2.returnOneArr[0]"
                    style="cursor: pointer"
                    href="javascript:void(0)"
                    @click="
                      openPushStatusDetailDialog(
                        tr.orderReturn2.returnArrs,
                        tr.pushStatus,
                        '2'
                      )
                    "
                    >查看详情</a
                  >

                  <div v-else></div>

                  <vs-button
                    v-if="tr.status != 0"
                    type="border"
                    size="small"
                    variant="info"
                    style="padding: 5px 10px"
                    @click="refreshOrder(tr)"
                    >查询</vs-button
                  >
                  <div v-else></div>
                </div>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
    <vs-pagination
      class="mt-6"
      :total="totalPage"
      v-model="currentx"
      @input="gotoCurrentPage"
    ></vs-pagination>

    <vs-popup :title="popUpTitle" :active.sync="logisticsPopUpActive">
      <div class>
        <!-- <div class="mb-4">
          更新订单号: {{ curSub.order_no_id }} 下商品:
          {{ curSub.name }} 的物流信息
        </div> -->
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">选择物流公司</label>
            <v-select
              :options="logisticsList"
              v-model="logistics_code"
              label="name"
            />
          </div>
        </div>
        <div class="vx-row mb-4" v-if="notshunfeng">
          <div class="vx-col w-full">
            <label class="mb-5">填写物流单号</label>
            <vs-input class="w-full" v-model="logistics_number" />
          </div>
        </div>

        <div class="flex mt-4">
          <vs-button
            class="mr-3"
            @click="updateLogistics"
            :disabled="btnDisabled"
            >确定更新</vs-button
          >
          <vs-button
            type="border"
            @click="cancelLogistics"
            :disabled="btnDisabled"
            >关闭</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup :title="popUpTitle" :active.sync="deleteOrderPopUpActive">
      <div class>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">此操作将删除订单不可恢复，是否确认删除？</label>
          </div>
        </div>
        <div class="flex mt-4">
          <vs-button
            class="mr-3"
            @click="acceptDeleteAlert"
            :disabled="btnDisabled"
            >确定</vs-button
          >
          <vs-button type="border" @click="deleteOrderPopUpActive = false"
            >关闭</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup :title="popUpTitle" :active.sync="statusPopUpActive">
      <div class>
        <div class="mb-4">
          更新订单号: {{ curSub.order_no_id }} 下商品:
          {{ curSub.name }} 的订单状态
        </div>
        <div class="vx-row mb-4">
          <div class="vx-col w-full">
            <label class="mb-5">选择订单状态</label>
            <v-select :options="statusList" v-model="status" label="name" />
          </div>
        </div>

        <div class="flex mt-4">
          <vs-button class="mr-3" @click="updateStatus" :disabled="btnDisabled"
            >确定更新</vs-button
          >
          <vs-button type="border" @click="closeStatus" :disabled="btnDisabled"
            >关闭</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup :title="popUpTitle" :active.sync="logisticsDetailPopUpActive">
      <div class>
        <p class="mb-3">物流状态: {{ logisticsState }}</p>
        <div v-if="logisticsItems.length > 0">
          <vs-list>
            <vs-list-item
              v-for="(item, index) in logisticsItems"
              :key="index"
              :title="item.context"
              :subtitle="item.ftime"
            ></vs-list-item>
          </vs-list>
        </div>
      </div>
    </vs-popup>

    <vs-popup :title="pushStatusPopTitle" :active.sync="popupActivo">
      <div>
        <div
          class="log_bg"
          v-for="(item, index) in popDescriptionArrs"
          :key="index"
        >
          <div class="middle_bg">
            <div class="yuan"></div>
            <div class="middle_line"></div>
          </div>
          <div class="desc_bg">
            <div class="desc">{{ item.error }}</div>
          </div>
          <div class="time_bg">
            <div class="date">{{ item.updated_at }}</div>
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup title="导入第三方订单" :active.sync="showImportModal">
      <div style="margin-top: 0.88em">
        <input
          type="file"
          class="pointer"
          data-file-type=".xlsx"
          data-post-url="/api/admin/order/leadingIn"
          data-import-type="vendor_orders"
          v-on:change.prevent="fileChange"
        />
        <button class="btn info" style="margin-right: 0.3rem">
          <i class="fa fa-upload"></i> 导入excel
        </button>
      </div>
    </vs-popup>

    <push-order-detail
      ref="pushOrderConfig_dom"
      @closeEmitConfigDetail="closeConfigOrderDetail"
    ></push-order-detail>

    <pay-modal @getOrderList="getOrderList" ref="payModalDom"></pay-modal>
  </div>
</template>
<script>
import PushConfigDetail from '../order/import/PushConfigDetail.vue'
import payModal from '../order/import/payModal.vue'

import ordeRepo from '@/repo/order'
import { getOrderDemo } from '@/repo/orderdemo'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import logisticsRepo from '@/repo/logistics'
import vSelect from 'vue-select'
export default {
  name: 'OrderIndex',
  components: {
    'v-select': vSelect,
    flatPickr,
    'push-order-detail': PushConfigDetail,
    'pay-modal': payModal,
  },
  data() {
    return {
      userID: null,
      deleteOrderPopUpActive: false,
      vendorOrdersImporting: false,
      showImportModal: false,
      noDataText: '',
      page: 1,
      keyword: '',
      list: [],
      selected: [],
      itemsPerPage: 10,
      totalPage: 0,
      currentx: 1,
      popUpTitle: '',
      logisticsPopUpActive: false,
      logisticsDetailPopUpActive: false,
      statusPopUpActive: false,
      logisticsList: [],
      logistics_code: '',
      logistics_number: '',
      btnDisabled: false,
      curSub: {
        order_id: '',
        name: '',
      },
      logisticsState: '',
      logisticsItems: [],
      statusList: [
        {
          value: 100,
          name: '全部',
          active: 1,
          id: 1,
        },
        {
          value: 0,
          name: '待付款',
          active: 0,
          id: 2,
        },
        {
          value: 1,
          name: '已支付(待发货)',
          active: 0,
          id: 3,
        },
        {
          value: 2,
          name: '待收货',
          active: 0,
          id: 4,
        },
        {
          value: 3,
          name: '已完成',
          active: 0,
          id: 5,
        },
        {
          value: 4,
          name: '已取消',
          active: 0,
          id: 6,
        },
        {
          value: 5,
          name: '退款中',
          active: 0,
          id: 7,
        },
        {
          value: 6,
          name: '退款完成',
          active: 0,
          id: 8,
        },
      ],
      status: 100,
      start: '',
      end: '',
      configdateTimePicker: {
        enableTime: true,
        dateFormat: 'Y-m-d H:i',
      },
      popupActivo: false,
      pushStatusPopTitle: '',
      popDescriptionArrs: [],
      //-----
      val11: '',
      activePrompt11: false,
      ordSub: null,
      notshunfeng: true,
      //       inventoryStatus:{
      //   0:"无操作",
      //   1:"电子口岸已暂存",
      //   2:"电子口岸申报中",
      //   3:"发送海关成功",
      //   4:"发送海关失败",
      //   5:"预处理成功",
      //   100:"海关退单",
      //   120:"海关入库",
      //   200:"数据已接收",
      //   300:"人工审核",
      //   399:"海关审结",
      //   400:"待运抵",
      //   500:"查验",
      //   501:"扣留移送通关",
      //   502:"扣留移送缉私",
      //   503:"扣留移送法规",
      //   599:"其它扣留",
      //   700:"退运",
      //   800:"放行",
      //   899:"结关",
      //   900:"退货",
      //   1001:"身份验证中",
      //   1002:"身份验证不通过",
      //   1003:"平台已暂存",
      //   1006:"正在发往电子口岸"
      // }
      // passNoToConfigDialog: 0,
    }
  },
  mounted() {
    this.noDataText = '加载中...'
    this.$route.query.u_id && (this.userID = this.$route.query.u_id)
    this.getOrderList()
    this.getLogisticsList()
  },
  watch: {
    logistics_code() {
      if (this.logistics_code) {
        if (this.logistics_code.code == 'shunfeng') {
          this.notshunfeng = false
        } else {
          this.notshunfeng = true
        }
      }
    },
  },

  methods: {
    openImportModal: function () {
      this.showImportModal = true
    },

    //获取物流公司列表
    getLogisticsList: function () {
      logisticsRepo.list((error, data) => {
        if (data.code === 0) {
          this.logisticsList = data.data
        }
      })
    },

    openPay(item) {
      this.$refs.payModalDom.open(item)
    },

    getOrderList: function () {
      this.$vs.loading()
      const page = this.page
      // console.log('this page:', page)
      const keyword = this.keyword
      const status = this.status
      const start = this.start
      const end = this.end
      const userId = this.userID
      let that = this
      ordeRepo.list(
        page,
        keyword,
        status,
        start,
        end,
        userId,
        (error, data) => {
          that.$vs.loading.close()
          if (data.code === 0) {
            // console.log('订单列表', data)
            // console.log(typeof data.data.data[1].pushStatus)
            data.data.data.forEach(function (item) {
              item.orderReturn1 = {
                returnOneArr: [],
                returnArrs: [],
              }
              item.orderReturn2 = {
                returnOneArr: [],
                returnArrs: [],
              }
              item.orderReturn3 = {
                returnOneArr: [],
                returnArrs: [],
              }
              item.orderReturn4 = {
                returnOneArr: [],
                returnArrs: [],
              }

              if (item.pushLog.length) {
                item.pushLog.forEach(function (data) {
                  if (data.type == 1) {
                    item.orderReturn1.returnArrs.push(data)
                    if (item.orderReturn1.returnOneArr.length < 1) {
                      item.orderReturn1.returnOneArr.push(data)
                    }
                  } else if (data.type == 2) {
                    item.orderReturn2.returnArrs.push(data)
                    if (item.orderReturn2.returnOneArr.length < 1) {
                      item.orderReturn2.returnOneArr.push(data)
                    }
                  } else if (data.type == 3) {
                    item.orderReturn3.returnArrs.push(data)
                    if (item.orderReturn3.returnOneArr.length < 1) {
                      item.orderReturn3.returnOneArr.push(data)
                    }
                  } else if (data.type == 4) {
                    item.orderReturn4.returnArrs.push(data)
                    if (item.orderReturn4.returnOneArr.length < 1) {
                      item.orderReturn4.returnOneArr.push(data)
                    }
                  }
                })
              }
            })
            that.list = data.data.data
            // console.log('订单列表', data.data.data)
            const total = data.data.total
            const perCount = data.data.per_page
            that.totalPage = Math.ceil(total / perCount)
            if (that.totalPage === 0) {
              that.noDataText = '订单数据为空'
            } else {
              that.noDataText = ''
            }
          }
        }
      )
    },

    gotoCurrentPage: function () {
      this.page = this.currentx
      this.getOrderList()
    },

    queryOrder: function () {
      this.page = 1
      this.getOrderList()
    },

    queryOrderByStatus: function (status, id) {
      this.page = 1
      this.list = []
      // this.keyword = ''
      this.status = status
      // this.statusList.forEach((item, index) => {
      //   console.log(item)
      //   if (item.id == id) {
      //     item.active = 1
      //   } else {
      //     item.active = 0
      //   }
      // })
      // console.log(id)
      this.getOrderList()
    },

    openStatus: function (sub) {
      // console.log(sub)
      this.statusPopUpActive = true
      this.popUpTitle = '更新订单状态'
      this.curSub = sub
    },

    closeStatus: function () {
      this.statusPopUpActive = false
    },

    updateStatus: function () {
      const curId = this.curSub.id

      let status = this.status.value

      if (status === '') {
        this.openNotify('请选择订单状态')
      } else {
        if (status === 0 || status === 4) {
          this.openNotify('订单状态不允许修改')
        } else {
          // const logistics_number = this.curSub.logistics_number

          // if (!logistics_number && status !== 1) {
          //   this.openNotify('请先添加物流信息')
          // } else {
          const postData = {
            id: curId,
            status: status,
          }
          ordeRepo.updateItemStatus(postData, (error, data) => {
            if (error) {
              this.openNotify('更新订单状态失败')
            }
            console.log(data)
            if (data.code === 0) {
              this.openNotify(data.msg, 'success')
            } else {
              this.openNotify(data.msg)
            }
          })
          // }
        }
      }
    },

    cancelLogistics: function () {
      this.logisticsPopUpActive = false
    },

    openNotify: function (msg, color = 'danger') {
      this.$vs.notify({
        position: 'bottom-center',
        color: color,
        title: '操作提示',
        text: msg,
      })
    },
    // 下载订单
    exportOrder: function (e) {
      const keyword = this.keyword
      const start = this.start
      const end = this.end
      const status = this.status
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.style = 'display: none'

      a.href =
        env.API_HOST +
        'admin/order/export?start=' +
        start +
        '&end=' +
        end +
        '&keyword=' +
        keyword +
        '&status=' +
        status
      a.click()
      e.preventDefault()
      document.body.removeChild(a)
    },

    /**
     * @description table-method,物流pop
     */
    openLogistics: function (sub) {
      this.notshunfeng = true
      this.logisticsPopUpActive = true
      this.popUpTitle = '更新物流信息'
      this.curSub = sub
      this.logistics_number = sub.logistics_number
      this.logistics_code = this.logisticsList.find((v) => {
        return v.code == sub.logistics_code
      })
      // this.logistics_code = sub.logistics_code
    },

    /**
     * @description table-物流弹窗method>更新method
     */
    updateLogistics: function () {
      let params
      // console.log(this.logistics_code.code)
      if (this.logistics_code.code == 'shunfeng') {
        params = {
          orderNo: this.curSub.order_id,
          logistics_company: this.logistics_code.name,
          logistics_code: this.logistics_code.code,
          logistics_number: '',
        }
        ordeRepo.updateLogistics(params, (error, data) => {
          if (error) {
            this.openNotify('更新物流信息失败')
            console.log(error)
            console.log(data)
          }
          if (data.code === 0) {
            this.openNotify(data.msg, 'success')
            this.getOrderList()
            this.logisticsPopUpActive = false
          } else {
            this.openNotify(data.msg)
          }
        })
      } else if (this.logistics_code === '') {
        this.openNotify('请选择一个物流公司')
      } else if (this.logistics_number === '') {
        this.openNotify('请填写物流单号')
      } else {
        params = {
          orderNo: this.curSub.order_id,
          logistics_company: this.logistics_code.name,
          logistics_code: this.logistics_code.code,
          logistics_number: this.logistics_number,
        }

        ordeRepo.updateLogistics(params, (error, data) => {
          if (error) {
            this.openNotify('更新物流信息失败')
          }
          if (data.code === 0) {
            this.openNotify(data.msg, 'success')
            this.getOrderList()
            this.logisticsPopUpActive = false
          } else {
            this.openNotify(data.msg)
          }
        })
      }
    },

    /**
     * @description open status dialog
     */
    openPushStatusDetailDialog: function (returnArrs, statusTag, title) {
      this.popDescriptionArrs = returnArrs

      let status = ''
      if (!statusTag) {
        status = '订单状态未知'
      } else {
        if (title == 3) {
          if (!statusTag.orderStatus) {
            status = status = '订单状态未知'
          } else {
            status = this.getStatus(statusTag.orderStatus)
          }
        } else if (title == 2) {
          if (!statusTag.paymentStatus) {
            status = status = '订单状态未知'
          } else {
            status = this.getStatus(statusTag.paymentStatus)
          }
        } else if (title == 1) {
          if (!statusTag.logisticsStatus) {
            status = status = '订单状态未知'
          } else {
            status = this.getStatus(statusTag.logisticsStatus)
          }
        } else if (title == 4) {
          if (!statusTag.inventoryStatus) {
            status = status = '订单状态未知'
          } else {
            status = this.getStatus(statusTag.inventoryStatus)
          }
        }
      }

      // console.log(document.body.clientWidth)
      // console.log(document.body.clientHeight)

      this.popupActivo = true
      if (title == 3) {
        this.pushStatusPopTitle = '订单推单状态 : ' + status
      } else if (title == 2) {
        this.pushStatusPopTitle = '支付单推单状态 : ' + status
      } else if (title == 1) {
        this.pushStatusPopTitle = '运单推单状态 : ' + status
      } else if (title == 4) {
        this.pushStatusPopTitle = '清单推单状态 : ' + status
      }
    },

    /**
     * @description open config dialog
     */
    openPushDetail: function (rowNo) {
      // this.passNoToConfigDialog = rowNo;
      this.$refs.pushOrderConfig_dom.openDialog(rowNo)
    },

    closeConfigOrderDetail: function () {},

    acceptAlert11() {
      this.$vs.notify({
        color: 'success',
        title: 'Accept Selected',
        text: 'Lorem ipsum dolor sit amet, consectetur',
      })
    },
    close11() {
      this.$vs.notify({
        color: 'danger',
        title: '错误提示',
        text: 'You close a dialog!',
      })
    },

    handleFileChange() {
      let inputDOM = this.$refs.inputer
      let file = inputDOM.files[0]
      // let size = Math.floor(file.size / 1024); //后续如需判断文件大小开启
      let formData = new FormData()
      formData.append('file', file)
      this.$refs.inputer.value = '' //清空value便于下一次上传
      ordeRepo.fileUpload(formData, (error, data) => {
        if (data.code === 0) {
          this.openNotify('导入成功')
          this.getOrderList()
        } else {
          this.openNotify(data.msg)
        }
      })
    },

    deletes(sub) {
      if (sub.order_id) {
        this.deleteOrderPopUpActive = true
      }
      this.popUpTitle = '删除订单'
      // this.ordSub = '[' + sub.order_id + ']'
      this.ordSub = JSON.stringify({ 0: `${sub.order_id}` })
    },
    acceptDeleteAlert() {
      const params = {
        orderNo: this.ordSub,
      }
      let that = this
      that.btnDisabled = true
      ordeRepo.deletesRow(params, (error, data) => {
        that.btnDisabled = false
        that.deleteOrderPopUpActive = false
        console.log(error, data)
        if (data.code === 0) {
          that.$vs.notify({
            color: 'success',
            title: 'Deleted success',
            text: data.msg,
          })
          that.getOrderList()
        } else {
          that.$vs.notify({
            color: 'danger',
            title: '错误提示',
            text: data.msg,
          })
        }
      })
    },
    getStatus(status) {
      if (status == undefined) {
        return null
      } else if (status < 0) {
        return '系统异常处理'
      } else if (status == 0) {
        return '无操作'
      } else if (status == 1) {
        return '电子口岸已暂存'
      } else if (status == 2) {
        return '电子口岸申报中'
      } else if (status == 3) {
        return '发送海关成功'
      } else if (status == 4) {
        return '发送海关失败'
      } else if (status == 5) {
        return '预处理成功'
      } else if (status == 100) {
        return '海关退单'
      } else if (status == 120) {
        return '海关入库'
      } else if (status == 200) {
        return '数据已接收'
      } else if (status == 300) {
        return '人工审核'
      } else if (status == 399) {
        return '海关审结'
      } else if (status == 400) {
        return '待运抵'
      } else if (status == 500) {
        return '查验'
      } else if (status == 501) {
        return '扣留移送通关'
      } else if (status == 502) {
        return '扣留移送缉私'
      } else if (status == 503) {
        return '扣留移送法规'
      } else if (status == 599) {
        return '其它扣留'
      } else if (status == 700) {
        return '退运'
      } else if (status == 800) {
        return '放行'
      } else if (status == 899) {
        return '结关'
      } else if (status == 900) {
        return '退货'
      } else if (status == 1001) {
        return '身份验证中'
      } else if (status == 1002) {
        return '身份验证不通过'
      } else if (status == 1003) {
        return '平台已暂存'
      } else if (status == 1006) {
        return '正在发往电子口岸'
      } else {
        return '订单未知状态'
      }
    },
    // 下载订单模板
    getDemo() {
      let url = env.API_HOST + 'admin/order/leadingIn/template/upload'
      var a = document.createElement('a')
      document.body.appendChild(a)
      a.style = 'display: none'
      a.href = url
      a.click()
      a.remove()
      // getOrderDemo().then((res) => {
      //   var blob = new Blob([res.data], {
      //     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      //   })
      //   var objectUrl = URL.createObjectURL(blob)
      //   var a = document.createElement('a')
      //   document.body.appendChild(a)
      //   a.style = 'display: none'
      //   a.href = objectUrl
      //   a.download = '订单模板.xls'
      //   a.click()
      //   document.body.removeChild(a)
      // })
    },
    refresh() {
      // let status = JSON.parse(JSON.stringify(this.statusList))
      this.getOrderList()
      this.openNotify('刷新成功', 'success')
      this.get
    },
    refreshOrder(item) {
      ordeRepo.refreshPayment(
        {
          orderNo: item.order_id,
        },
        (err, data) => {
          if (err) {
            this.openNotify(data.msg)
          } else {
            if (data.code === 0) {
              this.getOrderList()
              setTimeout(() => {
                this.openNotify('查询成功', 'success')
              }, 500)
            } else {
              this.openNotify(data.msg)
            }
          }
        }
      )
    },
  },
}
</script>
<style lang="scss">
.con-vs-dialog {
  .vs-dialog {
    max-width: 82vw;
  }
}
.text-muted {
  color: #999;
}
.log_bg {
  display: flex; /* 弹性布局 */
  flex-direction: row; /* 水平方向 */
  padding-top: 15px;
  padding-bottom: 15px;
  background: #ffffff;
  position: relative;
}

.log_bg .time_bg {
  width: 110px;
  font-size: 13px;
}

.log_bg .time_bg .date {
  color: #404245;
  margin-left: 20px;
}

/* .log_bg .time_bg .hour {
  color: #A2A6AD;
  margin-left: 20px;
} */
.white {
  background-color: #fff;
}
.log_bg .middle_bg {
  margin-left: 36px;
  width: 11px;
  position: absolute;
  height: 100%;
  top: 1px;
}

.log_bg .middle_bg .middle_line {
  border-left: 1px dashed #e0e3da;
  height: 100%;
}

.log_bg .middle_bg .yuan {
  position: absolute;
  left: -4px;
  top: 19px;
  width: 8px;
  height: 8px;
  background: #d1d1d1;
  border-radius: 50%;
}

.log_bg:first-child .middle_bg .middle_line {
  border-left: 1px dashed #e0e3da;
  height: 100%;
  margin-top: 19px;
}

.log_bg:first-child .middle_bg .yuan {
  position: absolute;
  left: -6px;
  top: 19px;
  width: 12px;
  height: 12px;
  background: #404245;
  border-radius: 50%;
}

.log_bg:last-child .middle_bg .middle_line {
  border-left: 1px dashed #e0e3da;
  height: 100%;
  margin-bottom: 19px;
}

.log_bg .desc_bg {
  width: calc(100% - 122px);
  padding-left: 84px;
}

.log_bg .desc_bg .desc {
  word-break: break-all;
  font-size: 14px;
  color: #404245;
}

/////////////////////////////////

.app-upload-button {
  padding: 0.75rem 2rem;
  background: rgba(var(--vs-primary), 1) !important;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  color: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: transparent;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  font-size: 1rem;
  display: initial;
  position: relative;
  cursor: pointer;
}

.app-upload-button input {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
}
////////////////////////////////
// .order-table .vs-con-table table {
//   width: 150% !important;
// }
.order-table .vs-con-table table .order-td {
  width: 100%;
  vertical-align: top;
  // text-overflow: ellipsis;
}
// .order-table table{
//   width: 200% !important;
//   max-width: 200% !important;
// }

// @media (min-width: 992px){}
.td-push {
  text-overflow: ellipsis;
  width: 200px !important;
  height: 210px !important;
  overflow: hidden;
}

// .shop-info-insert .vs-con-table table {
//   width: 100% !important;
// }
</style>
